








































































import Vue from 'vue';
import { mapState } from 'vuex';
import { AppState } from '@/vuex/store';
import RemarkRuleCreate from '../components/remarkRules/Create.vue';
import RemarkRuleItem from '../components/remarkRules/Item.vue';
import RemarkRuleStat from '../components/remarkRules/Stat.vue';
import SidePage from 'common/components/ui/SidePage/index.vue';
import customerClient from '../apis';
import { CustomerRemarkRule } from '../models/CustomerRemarkRule';
import Customer from '../models/Customer';

enum RuleMode {
  Valid = 0,
  Expired = -1,
  Disabled = -100,
}

export default Vue.extend({
  components: {
    RemarkRuleCreate,
    RemarkRuleItem,
    RemarkRuleStat,
    SidePage,
  },
  data() {
    return {
      total: 0,
      page: 1,
      size: 30,
      dataLoaded: false,
      showCreate: false,
      showStat: false,
      slinks: [] as CustomerRemarkRule[],
      mode: RuleMode.Valid,
      refresherId: 0,
      statRule: null,
      RuleMode,
    };
  },
  computed: mapState({
    customerRemarkRules(state: AppState): CustomerRemarkRule[] {
      return state.customerState.customerRemarkRules;
    },
  }),
  methods: {
    loadRemarkRules(value: RuleMode) {
      this.dataLoaded = false;
      if (value === RuleMode.Expired) {
        this.loadExpiredRemarkRules();
      } else if (value === RuleMode.Disabled) {
        this.loadDisabledRemarkRules();
      } else {
        this.loadValidRemarkRules();
      }
    },
    loadValidRemarkRules() {
      customerClient.getValidRemarkRules({
        page: this.page,
        size: this.size,
      }).success((r: any) => {
        this.$store.commit('UPDATE_CUSTOMER_REMARK_RULES', r.rules);
        this.slinks = r.slinks;
        this.total = r.total;
        this.dataLoaded = true;
      });
    },
    loadExpiredRemarkRules() {
      customerClient.getExpiredRemarkRules({
        page: this.page,
        size: this.size,
      }).success((r: any) => {
        this.$store.commit('UPDATE_CUSTOMER_REMARK_RULES', r.rules);
        this.slinks = r.slinks;
        this.total = r.total;
        this.dataLoaded = true;
      });
    },
    loadDisabledRemarkRules() {
      customerClient.getDisabledRemarkRules({
        page: this.page,
        size: this.size,
      }).success((r: any) => {
        this.$store.commit('UPDATE_CUSTOMER_REMARK_RULES', r.rules);
        this.slinks = r.slinks;
        this.total = r.total;
        this.dataLoaded = true;
      });
    },
    showEdit(rule: CustomerRemarkRule) {
      this.$store.commit('SET_CUSTOMER_REMARK_RULE', JSON.parse(JSON.stringify(rule)));
      this.showCreate = true;
    },
    showCreateBox() {
      this.$store.commit('RESET_CUSTOMER_REMARK_RULE');
      this.showCreate = true;
    },
    showStatBox(rule: CustomerRemarkRule) {
      this.statRule = rule;
      this.showStat = true;
    },
    onPageChange(page: number) {
      this.page = page;
      this.loadRemarkRules(this.mode);
    },
    onPageSizeChange(pageSize: number) {
      this.size = pageSize;
      this.loadRemarkRules(this.mode);
      Vue.localStorage.set('remarksRulesPageSize', pageSize);
    },
  },
  beforeMount() {
    this.size = parseInt(Vue.localStorage.get('remarksRulesPageSize', 30));
  },
  mounted() {
    this.loadRemarkRules(this.mode);
  },
  watch: {
    mode(value: number) {
      this.loadRemarkRules(value);
    },
    refresherId() {
      this.loadRemarkRules(this.mode);
    },
  },
});
